import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function TeamReducer(state = initialState.team, action: any) {
  switch (action.type) {
    case types.SAVE_TEAM_SUCCESS:
      return action.team;
    default:
      return state;
  }
}
